import { ActionLogger } from "../ActionLogger";
import { IActionLogger } from "../interfaces/IActionLogger";

const defaultActionExpiryTime = 5000 * 60;
const defaultExpiryCheckTime = 2000 * 60;

export const actionLogger: IActionLogger = new ActionLogger(defaultActionExpiryTime, defaultExpiryCheckTime);
